import {IRestrictionsService} from "./restrictions.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IGameRestriction} from "./game-restriction.interface";
import {GameInfo} from "../games/game-info";

export class RestrictionsService extends ServiceBase implements IRestrictionsService {
    getGenericRestrictionMessage(): string {
        return this.services.translation.translate('100200');
    }

    getGameRestriction(gameInfo: GameInfo): IGameRestriction {
        return this.services.sdk.getGameRestriction(gameInfo.gameType, gameInfo.gameGroupId, gameInfo.vendorId);
    }
}